import React, { useEffect } from 'react';
import styles from 'assets/css/Card.module.css';
//import useCardDisplayState, { useCardToggle } from 'context/CardCenterContext';
import useComponentDisplayState, { useComponentToggle } from 'context/ComponentToggleContext';
import classNames from 'classnames';

export default function withToggleCard(Component) {
    function WithToggleCard({additionalClassNames, ...props}) {
        const { addComponent } = useComponentToggle(props.componentName);
        const isCardShown = useComponentDisplayState(props.componentName);
        
        useEffect(() => {
            //console.log(`[CardContent] - OneTime addCard(toggle) call: ${props.type}`);
            addComponent(props.defaultToggleState);
        }, [props.defaultToggleState, addComponent]);

        const classes = classNames(additionalClassNames, {
            [`${styles.hideCard}`]: !isCardShown
        });

        return (
            <Component {...props} additionalClassNames={classes} />
        );
    }

    return WithToggleCard;
}